import { PaginationOptions, PaginatedResult } from 'types/api';
import useSWR, { invalidateStartsWith } from 'hooks/useSWR';
import { useSWRResource } from 'util/resource/useSWRResource';
import { withPagination } from 'apis/utils';
import config from 'config';
import { Conversation } from './conversationTypes';

export const conversationListKey = (paginationOptions?: PaginationOptions) => {
  if (!paginationOptions) return undefined;
  return withPagination(`${config.COMPANIES_API_URL}/conversations`, paginationOptions);
};

export const reloadConversationList = () => {
  invalidateStartsWith([`${config.COMPANIES_API_URL}/conversations?page`]);
};

export const useConversationList = (paginationOptions?: PaginationOptions) => {
  const swrResult = useSWR<PaginatedResult<Conversation>>(conversationListKey(paginationOptions), undefined, {
    revalidateIfStale: true,
  });

  const swrResource = useSWRResource(swrResult);

  return swrResource;
};
